module.exports = __webpack_public_path__ + "static/media/adminSteptwoActive.d539b3b3.png";